export {default} from './TipsSettingsError';
